import axios from 'axios';
import UsersListModel from './UsersListModel';


export default class UsersListViewModel {
    users: UsersListModel[];
    totalPages: number;
    constructor() {
        this.users = [];
        this.totalPages = 0;
    }

    async loadData(pageNumber: number, pageSize: number) {
        try {
            const API_URL = process.env.REACT_APP_API_URL
            const idToken : string | null = localStorage.getItem("IdToken");
            const response = await axios.get(`${API_URL}/v1/users`, {
                params: {
                    page: pageNumber,
                    pageSize: pageSize,
                },
                headers:{
                    'Authorization': `${idToken}`
                }
            });

            const data = response.data.response.items;
            this.users = data;
            this.totalPages = response.data.response.totalPages
        } catch (error) {
            console.error('Failed to load user data:', error);
        }
    }
}